import { Layout } from '../components/layout/Layout';
import { privacyIntro, privacySections } from '../constants/privacyPolicyContent';

const LegalParagraph = ({ children }) => (
  <p className="text-cpre-new-yew/80 leading-relaxed mb-4 last:mb-0">{children}</p>
);

const LegalHeading = ({ level = 2, children }) => {
  if (level === 3) {
    return (
      <h3 className="font-heading text-xl font-semibold text-cpre-new-yew mt-6 mb-3">
        {children}
      </h3>
    );
  }
  return (
    <h2 className="font-heading text-2xl font-semibold text-cpre-new-yew mt-10 mb-4 first:mt-0">
      {children}
    </h2>
  );
};

const LegalList = ({ items }) => (
  <ul className="list-disc pl-6 mb-4 space-y-2 text-cpre-new-yew/80">
    {items.map((item) => (
      <li key={item} className="leading-relaxed">
        {item}
      </li>
    ))}
  </ul>
);

const renderSubsections = (subsections) =>
  subsections.map((sub) => (
    <div key={sub.title}>
      <LegalHeading level={3}>{sub.title}</LegalHeading>
      {sub.paragraphs.map((text) => (
        <LegalParagraph key={text.slice(0, 40)}>{text}</LegalParagraph>
      ))}
    </div>
  ));

const renderSection = (section) => (
  <section key={section.title}>
    <LegalHeading>{section.title}</LegalHeading>
    {section.paragraphs?.map((text) => (
      <LegalParagraph key={text.slice(0, 40)}>{text}</LegalParagraph>
    ))}
    {section.list && (
      <>
        <LegalParagraph>Information we collect from you directly or from third parties with whom we work, may include:</LegalParagraph>
        <LegalList items={section.list} />
      </>
    )}
    {section.paragraphsAfterList?.map((text) => (
      <LegalParagraph key={text.slice(0, 40)}>{text}</LegalParagraph>
    ))}
    {section.subsections && renderSubsections(section.subsections)}
  </section>
);

const PrivacyPage = () => (
  <Layout>
    <div data-testid="privacy-page">
      <section className="relative py-20 md:py-28 bg-cpre-new-yew overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'url("data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23ffffff" fill-opacity="0.4"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
            }}
          />
        </div>
        <div className="relative container-custom">
          <div className="max-w-3xl">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold text-white mb-6">
              Privacy Policy
            </h1>
            <p className="text-xl text-white/90 leading-relaxed">
              How CPRE Rutland and Lincolnshire collects, uses, and protects your personal information.
            </p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl">
            {privacyIntro.paragraphs.map((text) => (
              <LegalParagraph key={text.slice(0, 40)}>{text}</LegalParagraph>
            ))}
            {privacySections.map(renderSection)}
          </div>
        </div>
      </section>
    </div>
  </Layout>
);

export default PrivacyPage;
